// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import store from './store/store';
import router from './router';
import * as baseUrl from './http/baseUrl';
import '@/http/http.js';
import vueJsonp from 'vue-jsonp';
Vue.use(vueJsonp);

Vue.config.productionTip = false;
Vue.prototype.$baseUrl = baseUrl;

Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js